import { getLapsedClientsDescription, getNewClientsDescription, getProspectiveClientsDescription, getRegularClientsDescription, } from '../types';
import { DefaultSegmentName } from '../../../../../../../types/audience-segments';
import { t } from '../../../../../../../infra/i18n';
export var getSegmentDescription = function (segmentName) {
    switch (segmentName) {
        case DefaultSegmentName.new:
            return getNewClientsDescription();
        case DefaultSegmentName.regular:
            return getRegularClientsDescription();
        case DefaultSegmentName.lapsing:
            return getLapsedClientsDescription();
        case DefaultSegmentName.prospective:
            return getProspectiveClientsDescription();
        default:
            return '';
    }
};
var getSegmentSetter = function (segmentName, setters) {
    switch (segmentName) {
        case DefaultSegmentName.new:
            return setters.setNewClients;
        case DefaultSegmentName.regular:
            return setters.setRegular;
        case DefaultSegmentName.lapsing:
            return setters.setLapsing;
        case DefaultSegmentName.prospective:
            return setters.setProspective;
        default:
            return function () { };
    }
};
var getSegmentEnabledState = function (segmentName, audienceState) {
    switch (segmentName) {
        case DefaultSegmentName.new:
            return audienceState.newClients.enabled;
        case DefaultSegmentName.regular:
            return audienceState.regular.enabled;
        case DefaultSegmentName.lapsing:
            return audienceState.lapsing.enabled;
        case DefaultSegmentName.prospective:
            return audienceState.prospective.enabled;
        default:
            return false;
    }
};
var shouldShowWeeksSelector = function (segmentName, isEnabled) {
    return segmentName === DefaultSegmentName.new && isEnabled;
};
export var getLabelsByName = function () {
    var _a;
    return (_a = {},
        _a[DefaultSegmentName.new] = t('engage:campaign_builder.audience.new_clients'),
        _a[DefaultSegmentName.regular] = t('engage:campaign_builder.audience.regular_clients'),
        _a[DefaultSegmentName.lapsing] = t('engage:campaign_builder.audience.lapsed_clients'),
        _a[DefaultSegmentName.prospective] = t('engage:campaign_builder.audience.prospective_clients'),
        _a);
};
export var buildDefaultSegments = function (params) {
    var defaultSegments = params.defaultSegments, audienceState = params.audienceState, setNewClients = params.setNewClients, setRegular = params.setRegular, setLapsing = params.setLapsing, setProspective = params.setProspective;
    var setters = { setNewClients: setNewClients, setRegular: setRegular, setLapsing: setLapsing, setProspective: setProspective };
    var labelsByName = getLabelsByName(); // ✅ Call at runtime
    return (defaultSegments || [])
        .filter(function (segment) {
        // Filter out 'all' segment as it's handled separately
        if (segment.name === DefaultSegmentName.all)
            return false;
        return true;
    })
        .map(function (segment) {
        var isEnabled = getSegmentEnabledState(segment.name, audienceState);
        return {
            title: labelsByName[segment.name],
            description: getSegmentDescription(segment.name),
            value: isEnabled,
            setValue: getSegmentSetter(segment.name, setters),
            clients: segment.customers,
            showWeeksSelector: shouldShowWeeksSelector(segment.name, isEnabled),
        };
    });
};
